<template>
  <div class="stepper-wrapper">
    <div class="stepper-container">
      <v-stepper v-model="localStep" class="elev-0 custom-stepper mb-6" flat>
        <v-stepper-header>
          <v-stepper-step :complete="localStep > 1" editable :step="1">
            ข้อมูลร้านค้า
          </v-stepper-step>

          <v-divider />

          <v-stepper-step :complete="localStep > 2" editable :step="2">
            ยืนยันตัวตน
          </v-stepper-step>

          <v-divider />

          <v-stepper-step :complete="localStep > 3" editable :step="3">
            อัพโหลดเอกสาร
          </v-stepper-step>

          <v-divider />

          <v-stepper-step editable :step="4">
            ส่งแบบฟอร์ม
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stepper",
  props: {
    currentStep: { type: Number, required: false, default: null },
    value: { type: Number, required: false, default: null },
  },
  computed: {
    localStep: {
      get() {
        return this.currentStep != null ? this.currentStep : (this.value || 1);
      },
      set(val) {
        this.$emit("step-click", Number(val));
      },
    },
  },
};
</script>

<style scoped>
.stepper-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  padding-top: 80px;
}
.stepper-container {
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
}
.custom-stepper :deep(.v-stepper__step__step) {
  background: #ffffff !important;
  color: #111827;
  border: 1px solid #c5c6c9;
  cursor: default !important;
}
.custom-stepper :deep(.v-stepper__step--active .v-stepper__step__step) {
  background: #F4811F !important;
  color: #ffffff !important;
  border-color: #F4811F !important;
}
.custom-stepper :deep(.v-stepper__step--complete .v-stepper__step__step) {
  background: #ef4444 !important;
  color: #ffffff !important;
  border-color: #ef4444 !important;
}
.custom-stepper :deep(.v-stepper__step--editable) {
  cursor: pointer !important;
}
.custom-stepper :deep(.v-stepper__step),
.custom-stepper :deep(.v-stepper__label) {
  transition: none !important;
}
.custom-stepper :deep(.v-stepper__step:hover),
.custom-stepper :deep(.v-stepper__label:hover) {
  background: none !important;
  color: inherit !important;
}
.custom-stepper,
.custom-stepper :deep(.v-sheet),
.custom-stepper :deep(.v-stepper),
.custom-stepper :deep(.v-stepper__header) {
  background: transparent !important;
  box-shadow: none !important;
  border: 0 !important;
}
.custom-stepper :deep(.v-divider) {
  opacity: 0.25;
}
@media (max-width: 599px) {
  .stepper-wrapper { padding-top: 32px; }
  .custom-stepper :deep(.v-stepper__label) { font-size: 10px !important; }
}
</style>
